import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useRouteError } from 'react-router-dom';
import styles from './styles.module.scss';
import ErrorImage from '@/common/images/fault-image.webp';
import { Footer } from '@/entities/Footer';
import { Header } from '@/entities/Header';
import { CardBlank } from '@/shared/CardBlank';
import { MainButton } from '@/shared/MainButton';

// const errorMessage = (error: any) => {
//   if (error) {
//     if (error.toString().includes('[object')) {
//       return error.message ? error.message : 'Unknown message';
//     } else {
//       return error.toString();
//     }
//   } else {
//     return 'Unknown message';
//   }
// };

export const ErrorPage = () => {
  const navigate = useNavigate();
  const navigateToHome = () => {
    navigate('/');
    setTimeout(() => document.location.reload());
  };

  const error = useRouteError();

  return (
    <>
      <Header />
      <main className={cn('section', styles.main)}>
        <div className={cn('container', styles.container)}>
          <div className={styles.cardBlock}>
            <CardBlank className={styles.card}>
              <h2 className={styles.header}>
                <FormattedMessage defaultMessage="Ошибка" />
              </h2>
              {!!error && (
                <p>
                  <FormattedMessage defaultMessage="Что-то пошло не так" />
                </p>
              )}
              <MainButton
                id="error-page-back-to-home"
                text={
                  <FormattedMessage defaultMessage="Вернуться на главную" />
                }
                onClick={navigateToHome}
              />
            </CardBlank>
          </div>
          <div className={styles.imageBlock}>
            <img className={styles.image} src={ErrorImage} alt="error image" />
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};
